import script from "./InlineThresholdUpdater.vue?vue&type=script&setup=true&lang=js"
export * from "./InlineThresholdUpdater.vue?vue&type=script&setup=true&lang=js"

import "./InlineThresholdUpdater.vue?vue&type=style&index=0&id=306e7984&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-306e7984"]])

export default __exports__